// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"76":"3721aee5","243":"b4779db1"}[chunkId] + ".chunk.js";
};